import * as types from '../mutation-types'
import { ajaxFun } from '../actions'

// initial state
const state = {
  all: [],
  flag: false,
  time: '',
  teacherClass: []
}

// getters
const getters = {
  classList: state => state.all,
  teacherClassList: state => state.teacherClass
}

const actions = {
  clearClass ({ commit }) {
    commit(types.CLEAR_CLASS)
  },

  deleteClass ({ commit }, classId) {
    commit(types.DELETE_CLASS, classId)
  },

  addToClass ({ commit }, classModel) {
    commit(types.ADD_TO_CLASS, classModel)
  },

  receiveClass ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.flag, state.time, types.RECEIVE_CLASS)
  },

  teacherClass ({ commit, state }, teacherId) {
    commit(types.TEACHER_CLASS, teacherId)
  }
}

// mutations
const mutations = {
  [types.RECEIVE_CLASS] (state, classModel) {
    state.all = classModel
    state.flag = true
    state.time = new Date().getTime()
  },

  [types.ADD_TO_CLASS] (state, classModel) {
    state.all.push(classModel)
  },

  [types.CLEAR_CLASS] (state) {
    state.flag = false
  },

  [types.DELETE_CLASS] (state, classId) {
    state.all.splice(state.all.findIndex(item => item.classId === classId), 1)
  },

  [types.TEACHER_CLASS] (state, teacherId) {
    let teacherClass = []
    for (let i = 0; i < state.all.length; i++) {
      let item = state.all[i]
      for (var j = 0; j < item.teacherList.length; j++) {
        if (item.teacherList[j].teacherId == teacherId) {
          teacherClass.push(item)
          break
        }
      }
    }

    state.teacherClass = teacherClass
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/classes.js